export default {
  // —— Console/Admin OpenAPI ——
  'pages.openapi.overview.title': '오픈 플랫폼 개요',
  'pages.openapi.overview.loadFailed':
    '사용량 개요를 불러오지 못했습니다(API가 아직 준비되지 않았을 수 있음)',
  'pages.openapi.overview.docsTitle': '연동 가이드',
  'pages.openapi.overview.docsDesc':
    '오픈 플랫폼 BasePath는 /v1이며, 응답 봉투는 {code,message,data,request_id}입니다. API Key 사용 시 Authorization 헤더에 Bearer sk_live_... / sk_test_...를 넣으세요. 키 평문은 생성 또는 교체 시에만 한 번 표시되므로 안전하게 보관하세요.',
  'pages.openapi.overview.level': '현재 등급',
  'pages.openapi.overview.qps': 'QPS 한도',
  'pages.openapi.overview.apps': '앱 수',
  'pages.openapi.overview.appsSuffix': '(상한 {maxApps}, 앱당 Key {maxKeys})',
  'pages.openapi.overview.dailyUsage': '오늘 사용량',

  'pages.openapi.status.active': '활성',
  'pages.openapi.status.disabled': '비활성',

  'pages.openapi.apps.title': '앱 및 키',
  'pages.openapi.apps.listTitle': '내 앱',
  'pages.openapi.apps.create': '앱 만들기',
  'pages.openapi.apps.createModal': '앱 만들기',
  'pages.openapi.apps.name': '앱 이름',
  'pages.openapi.apps.nameRequired': '이름을 입력하세요',
  'pages.openapi.apps.description': '설명',
  'pages.openapi.apps.status': '상태',
  'pages.openapi.apps.createdAt': '생성 시간',
  'pages.openapi.apps.createSuccess': '앱이 생성되었습니다',
  'pages.openapi.apps.createFailed': '앱 생성 실패',
  'pages.openapi.apps.loadFailed': '앱을 불러오지 못했습니다',
  'pages.openapi.apps.keysLoadFailed': '키를 불러오지 못했습니다',
  'pages.openapi.apps.delete': '삭제',
  'pages.openapi.apps.deleteConfirm': '이 앱을 삭제할까요?',
  'pages.openapi.apps.deleted': '삭제됨',
  'pages.openapi.apps.createKey': 'Key 만들기',
  'pages.openapi.apps.createKeyModal': 'API Key 만들기',
  'pages.openapi.apps.keyCreateSuccess': '키가 생성되었습니다',
  'pages.openapi.apps.keyCreateFailed': '키 생성 실패',
  'pages.openapi.apps.noPlainKey': '평문 키가 반환되지 않았습니다',
  'pages.openapi.apps.plainKeyTitle': 'API Key를 안전하게 저장하세요',
  'pages.openapi.apps.plainKeyHint':
    '평문은 한 번만 표시되며, 닫으면 다시 볼 수 없습니다.',
  'pages.openapi.apps.copy': '복사',
  'pages.openapi.apps.copied': '복사됨',
  'pages.openapi.apps.copyFailed': '복사 실패. 직접 선택하세요',
  'pages.openapi.apps.close': '닫기',
  'pages.openapi.apps.key.name': '이름',
  'pages.openapi.apps.key.namePlaceholder': '프로덕션 주 Key',
  'pages.openapi.apps.key.prefix': '접두사',
  'pages.openapi.apps.key.env': '환경',
  'pages.openapi.apps.key.status': '상태',
  'pages.openapi.apps.key.createdAt': '생성 시간',
  'pages.openapi.apps.key.disable': '비활성화',
  'pages.openapi.apps.key.disableConfirm': '이 키를 비활성화할까요?',
  'pages.openapi.apps.key.disabled': '비활성화됨',
  'pages.openapi.apps.key.enable': '활성화',
  'pages.openapi.apps.key.enableConfirm': '이 키를 활성화할까요?',
  'pages.openapi.apps.key.enabled': '활성화됨',
  'pages.openapi.apps.key.rotate': '교체',
  'pages.openapi.apps.key.rotateConfirm':
    '교체 시 새 키가 생성되고 평문이 한 번만 반환됩니다. 계속할까요?',
  'pages.openapi.apps.key.rotated': '교체됨',
  'pages.openapi.apps.key.delete': '삭제',
  'pages.openapi.apps.key.deleteConfirm': '이 키를 삭제할까요? 복구할 수 없습니다.',
  'pages.openapi.apps.key.deleted': '삭제됨',

  'pages.openapi.logs.title': '호출 기록',
  'pages.openapi.logs.listTitle': '호출 상세',
  'pages.openapi.logs.dailyTitle': '최근 14일 사용량',
  'pages.openapi.logs.dailyEmpty': '일별 사용량 데이터가 없습니다',
  'pages.openapi.logs.date': '날짜',
  'pages.openapi.logs.count': '호출 수',
  'pages.openapi.logs.createdAt': '시간',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': 'API 응답의 request_id를 붙여넣으세요',
  'pages.openapi.logs.detail': '상세',
  'pages.openapi.logs.detailTitle': '호출 상세',
  'pages.openapi.logs.detailLoading': '로딩 중…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': '요청',
  'pages.openapi.logs.responseBody': '응답',
  'pages.openapi.logs.app': '앱',
  'pages.openapi.logs.appId': '앱 ID',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': '사용자 ID',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Key 접두사',
  'pages.openapi.logs.method': '메서드',
  'pages.openapi.logs.path': '경로',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': '업무 코드',
  'pages.openapi.logs.latency': '지연(ms)',
  'pages.openapi.logs.loadFailed': '불러오기 실패',

  'pages.openapi.planTiers.title': '오픈 플랫폼 요금제',
  'pages.openapi.planTiers.level': '등급',
  'pages.openapi.planTiers.levelTip':
    'Plan tier level (1–5), aligned with the user profile Level. Higher numbers mean higher tiers.',
  'pages.openapi.planTiers.name': '이름',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    'Max requests per second (Queries Per Second). Default rate limit for API Key calls on this tier: sustained rate equals this value; burst capacity is about QPS×2 (at least 5). Applies only to API Key calls; console/admin traffic is not counted. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42901).',
  'pages.openapi.planTiers.dailyQuota': '일일 할당량',
  'pages.openapi.planTiers.dailyQuotaTip':
    'Max total API requests allowed per calendar day. Counted per user/key; only API Key calls count. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42902).',
  'pages.openapi.planTiers.maxApps': '앱 수 상한',
  'pages.openapi.planTiers.maxAppsTip':
    'Maximum number of OpenAPI apps a developer on this tier can create.',
  'pages.openapi.planTiers.maxKeys': '앱당 Key 상한',
  'pages.openapi.planTiers.maxKeysTip': 'Maximum number of API keys allowed under each app.',
  'pages.openapi.planTiers.allowedScopes': 'Allowed permissions (scopes)',
  'pages.openapi.planTiers.allowedScopesTip':
    'API permission scopes this tier may request or be granted. App and API Key scopes must be a subset of this selection.',
  'pages.openapi.planTiers.save': '저장',
  'pages.openapi.planTiers.saved': '저장됨',
  'pages.openapi.planTiers.saveFailed': '저장 실패',
  'pages.openapi.planTiers.loadFailed': '요금제를 불러오지 못했습니다',
  'pages.openapi.planTiers.readonly':
    '관찰자는 읽기 전용이며 요금제 등급을 수정할 수 없습니다',

  'pages.openapi.admin.usageLogsTitle': '오픈 플랫폼 호출 감사',
  'pages.openapi.admin.usageLogsList': '전역 호출 기록',
  'pages.openapi.admin.disableKeyConfirm': '이 API Key를 비활성화할까요?',
  'pages.openapi.admin.disableKey': 'Key 비활성화',
  'pages.openapi.admin.keyDisabled': '비활성화됨',
  'pages.openapi.admin.appsTitle': '오픈 플랫폼 앱 관리',
  'pages.openapi.admin.appsList': '전체 개발자 앱',
  'pages.openapi.admin.developers': '개발자',
  'pages.openapi.admin.apps': '앱',
  'pages.openapi.admin.keys': '전체 Key',
  'pages.openapi.admin.activeKeys': '활성 Key',
  'pages.openapi.admin.todayRequests': '오늘 호출',
  'pages.openapi.admin.todayErrors': '오늘 오류',
  'pages.openapi.admin.errorCount': '오류',
  'pages.openapi.admin.owner': '소유자',
  'pages.openapi.admin.keyCount': 'Key 수',
  'pages.openapi.admin.keyword': '키워드',
  'pages.openapi.admin.keywordPlaceholder': '앱 이름 / 설명 / 테넌트 코드',
  'pages.openapi.admin.statsLoadFailed': '통계를 불러오지 못했습니다',
  'pages.openapi.admin.noKeys': 'Key 없음',
  'pages.openapi.admin.appEnabled': '앱 활성화됨',
  'pages.openapi.admin.appDisabled': '앱 비활성화됨',
  'pages.openapi.admin.appDisableConfirm': '이 앱을 비활성화할까요?',
  'pages.openapi.admin.appEnableConfirm': '이 앱을 활성화할까요?',
  'pages.openapi.admin.keyEnableConfirm': '이 키를 활성화할까요?',

  'pages.admin.user.section.openapi': '오픈 플랫폼',
  'pages.admin.user.openapiDeveloperEnabled': '오픈 플랫폼',
  'pages.admin.user.openapi.on': '개통됨',
  'pages.admin.user.openapi.off': '미개통',
  'pages.admin.user.openapiLevel': '오픈 플랫폼 등급',
  'pages.admin.user.openapiDeveloperEnabled.label': '개발자 개통',
  'pages.admin.user.openapiLevel.label': '등급',
  'pages.admin.user.openapiLevel.placeholder': '1-5',
};
